var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClockShield = function SvgClockShield(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00003 3.26994V9.61494C2.00004 11.6205 2.60779 13.5789 3.74316 15.2321C4.87853 16.8854 6.48821 18.1557 8.36003 18.8758L9.22753 19.2091C9.80523 19.4313 10.4448 19.4313 11.0225 19.2091L11.89 18.8758C13.7618 18.1557 15.3715 16.8854 16.5069 15.2321C17.6423 13.5789 18.25 11.6205 18.25 9.61494V3.26994C18.2516 3.03118 18.1842 2.79704 18.0559 2.59568C17.9276 2.39433 17.7438 2.23433 17.5267 2.13494C15.1932 1.11644 12.671 0.602161 10.125 0.625778C7.57907 0.602161 5.05683 1.11644 2.72336 2.13494C2.50626 2.23433 2.3225 2.39433 2.19417 2.59568C2.06585 2.79704 1.99843 3.03118 2.00003 3.26994V3.26994Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14C11.39 14 12.26 13.7361 13.0001 13.2416C13.7401 12.7471 14.3169 12.0443 14.6575 11.2221C14.9981 10.3998 15.0872 9.49501 14.9135 8.62209C14.7399 7.74918 14.3113 6.94736 13.682 6.31802C13.0526 5.68868 12.2508 5.2601 11.3779 5.08647C10.505 4.91283 9.60019 5.00195 8.77792 5.34254C7.95566 5.68314 7.25285 6.25991 6.75839 6.99994C6.26392 7.73996 6 8.60999 6 9.5C6 10.6935 6.47411 11.8381 7.31802 12.682C8.16193 13.5259 9.30653 14 10.5 14Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H10V8",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClockShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "clockShield.abe0aae58767750b9c5de7f9fadf64db.svg";